import { render, staticRenderFns } from "./Checkout-details.vue?vue&type=template&id=0f88cea2&scoped=true&"
import script from "./Checkout-details.vue?vue&type=script&lang=js&"
export * from "./Checkout-details.vue?vue&type=script&lang=js&"
import style0 from "./Checkout-details.vue?vue&type=style&index=0&id=0f88cea2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88cea2",
  null
  
)

export default component.exports